/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { guardrailsDeleteGuardrails } from "../../funcs/guardrailsDeleteGuardrails.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteGuardrailsRequest$inboundSchema,
};

export const tool$guardrailsDeleteGuardrails: ToolDefinition<typeof args> = {
  name: "guardrails-delete-guardrails",
  description: `Delete guardrails policy

Delete a guardrails policy. Omit team_id to delete the org-wide policy (org admin only); provide team_id to delete that team's policy (org admins may target any team in their org, other callers only their own team). Idempotent: deleting a policy that doesn't exist returns deleted: false.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await guardrailsDeleteGuardrails(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
